import api from './api';

export const getWorkHours = (params) => api.get('/v1/work-hours', { params });
export const getWorkHour = (id) => api.get(`/v1/work-hours/${id}`);
export const createWorkHour = (data) => api.post('/v1/work-hours', data);
export const updateWorkHour = (id, data) => api.put(`/v1/work-hours/${id}`, data);
export const deleteWorkHour = (id) => api.delete(`/v1/work-hours/${id}`);
export const batchDeleteWorkHours = (ids) => api.post('/v1/work-hours/batch-delete', ids);
